import React from 'react'
import styled from 'styled-components'
import { breakpoints } from '../css-variables'

function ContentWrapper({ className, children, tight = false }) {
  const displayTight = tight ? ' displayTight' : ''

  return <div className={`${className} ${displayTight}`}>{children}</div>
}

const StyledContentWrapper = styled(ContentWrapper)`
  margin-bottom: 31px;
  @media screen and ${breakpoints.tabletS} {
    margin-bottom: 61px;
  }

  &.displayTight {
    margin-bottom: 40px;
    @media screen and ${breakpoints.tabletS} {
      margin-bottom: 20px;
    }
  }
`

export default StyledContentWrapper
